import script from "./history.vue?vue&type=script&lang=ts&setup=true"
export * from "./history.vue?vue&type=script&lang=ts&setup=true"

import "./history.vue?vue&type=style&index=0&id=56aae4db&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56aae4db"]])

export default __exports__